const MiB = 1024 ** 2

/** Share of the peak hour by Beijing hour: quiet nights, a lunch dip and a busy afternoon. */
const DAY_PROFILE = [0.35, 0.22, 0.12, 0.08, 0.06, 0.06, 0.09, 0.2, 0.45, 0.75, 0.95, 1, 0.7, 0.85, 1, 0.98, 0.92, 0.88, 0.7, 0.55, 0.6, 0.65, 0.58, 0.45]
const PEAK_MIB_PER_MEMBER = 2.6 * 1024

/**
 * Sample traffic for the /org team-lines demo. Values are whole MiB in bytes so every
 * shown total adds up exactly, and there is no randomness so SSR and hydration match.
 */
export function linesDemoUsage(members: readonly string[]) {
  const weights = members.map((_, index) => 0.7 + ((index * 5 + 3) % 7) * 0.15)
  const bars = DAY_PROFILE.map((_, hour) => {
    const values = members.map((_, index) => {
      // Each member is shifted a little in time and gets a fixed ±15% wobble.
      const share = DAY_PROFILE[(hour + (index % 3) - 1 + 24) % 24]!
      const wobble = 0.85 + (((Math.imul(hour + 1, 2654435761) ^ Math.imul(index + 7, 40503)) >>> 0) % 1000) / 1000 * 0.3
      return Math.round(share * weights[index]! * wobble * PEAK_MIB_PER_MEMBER) * MiB
    })
    return { hour, values, bytes: values.reduce((sum, value) => sum + value, 0) }
  })
  const totals = members.map((_, index) => bars.reduce((sum, bar) => sum + bar.values[index]!, 0))
  return {
    bars,
    totals,
    /** Member indexes in legend order; DedicatedUsageChart lists the heaviest user first. */
    legendOrder: members.map((_, index) => index).sort((a, b) => totals[b]! - totals[a]! || a - b),
    total: totals.reduce((sum, value) => sum + value, 0),
    peak: Math.max(...bars.map(bar => bar.bytes)),
  }
}
